"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const app_bar_1 = __importDefault(require("react-toolbox/lib/app_bar"));
const content_1 = __importDefault(require("./views/content"));
const App = () => {
    return (React.createElement("div", { id: "App" },
        React.createElement(app_bar_1.default, { title: "\u3068\u3061\u3059\u307D\u3063\u3068\uFF01\uFF08\u03B2\u7248\uFF09", fixed: true, scrollHide: true, flat: true }),
        React.createElement(content_1.default, null)));
};
exports.default = App;
